export const getTopicsForBlackFridayCyberMondaySales = (locale: string) => {
    return TOPICS_BY_LANGUAGE[locale as keyof typeof TOPICS_BY_LANGUAGE] ?? TOPICS_BY_LANGUAGE.en;
};
/**
 * List of topics that should be shown for BFCM sales.
 * It is on the same order as defined by Product & Design.
 */
export const TOPICS_BY_LANGUAGE = {
    en: ['artificial-intelligence', 'python', 'excel', 'digital-marketing'],
    es: ['artificial-intelligence', 'python', 'excel', 'web-development'],
    pt: ['artificial-intelligence', 'excel', 'python', 'microsoft-power-bi'],
    ja: ['artificial-intelligence', 'python', 'chatgpt', 'web-development'],
};

export const CARD_CAROUSEL_PAGE_SIZE = 12;
export const MAX_CARDS_ON_STACKED_VIEW = 8;
